import InfoBox from '../../../../../components/minside/InfoBox';
import { formatPhoneNumber } from '../../../../../utils/formatNumber';

import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ListField({ label, value, action, loading = false }) {
    return (
        <div className="profile-field">
            <dt className="profile-field__label">{label}</dt>
            <dd className="profile-field__value">
                {loading ? (
                    <span>Laster...</span>
                ) : (
                    <>
                        <span>
                            {value || 'Ikke oppgitt'}
                            {action && ','}
                        </span>
                        {action && <span className="profile-field__action">{action}</span>}
                    </>
                )}
            </dd>
        </div>
    );
}

// Kompakt underseksjon: liten overskrift + tilhørende paragrafer.
// Brukes inne i en profile-section når vi vil dele opp innholdet i
// merket-baserte blokker (f.eks. én blokk per lunsj-scenario) uten å
// bruke definisjonslisten som er for korte verdier.
function InfoItem({ heading, children }) {
    return (
        <div className="info-item">
            <h5 className="info-item__heading">{heading}</h5>
            {children}
        </div>
    );
}

function InfoTab({ onNavigate }) {
    return (
        <div className="profile-tab">
            <section className="profile-section">
                <h4 className="profile-section__heading">Oppmøte</h4>
                <p>
                    Kommer du til Lom på ettermiddag/kveld så anbefaler vi at du kommer til
                    SAR61-teltet som er på utsiden av hovedbygget til Nordal Turistsenter. Der er
                    det sosial møteplass og middagsservering fra kl 18:00 hver kveld.
                </p>
                <p>
                    Kommer du til Lom på morgenen og skal delta på en workshop så reiser du direkte
                    til oppmøtested for workshopen. Det står i programmet hvor den enkelte workshop
                    gjennomføres, i tillegg til at det vises i kartet du finner under fanen
                    &quot;praktisk info&quot; på nettsiden. Det står også nederst i dette
                    infoskrivet.
                </p>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Sikkerhet gjennom uken</h4>
                <p>
                    Din og andres sikkerhet er det viktigste for oss. For å ivareta egen og andres
                    sikkerhet må du derfor følge rutiner og retningslinjer som anvist under
                    treningsuken og på øvelse Flåklypa lørdag. Du må sette deg godt inn i 5-punkts
                    ordrene for de workshopene du skal delta på, og øvingsdirektivet for øvelsen på
                    lørdag dersom du skal delta på denne.
                </p>
                <p>
                    5-punkts ordrene redegjør hva som skjer på workshopen og hvilken risiko du
                    eksponeres for og må ta hensyn til.
                </p>
                <p>
                    Øvingsdirektivet omhandler øvelsen lørdag 6. juni og kommuniserer det samme i et
                    litt større format. Her beskrives også risikoene du eksponeres for før og under
                    øvelsen. Dette må du sette deg inn i.
                </p>
                <p>
                    Vi har et eget sikkerhetsteam som vil bistå alle gjennom uken. Anmodning om
                    bistand eller varsling av hendelser rettes til leder av sikkerhetsteamet.
                </p>
                <InfoBox variant="warning">
                    <p>
                        5-punkts ordrene og øvingsdirektivet er sikkerhetskritisk lesning før
                        arrangementet.
                    </p>
                    <button
                        type="button"
                        className="info-box__button info-box__button--warning"
                        onClick={() => onNavigate?.('documents')}
                    >
                        Gå til Dokumenter
                    </button>
                </InfoBox>
                <InfoBox variant="info-muted">
                    <p>Kontaktperson leder sikkerhet: Tony Ugstad, tlf: 476 21 037.</p>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Observatør</h4>
                <p>
                    Skal du være med som observatør må du hente observatørvest i teltet før kl 08:00
                    på morgenen. Alle observatører SKAL bruke observatørvest. Observatører må følge
                    anvisningene som gis ute på postene, og under øvelsen på lørdag. Har du ikke
                    fått en konkret oppgave i øvelsen må du regne med å delta som observatør.
                </p>
                <InfoBox variant="info-muted">
                    <p>Kontaktperson observatører: Anita Solberg, tlf: 476 21 037.</p>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Utstyr</h4>
                <p>
                    Vi stiller med alt nødvendig utstyr til workshopene. Det eneste du må ta med er
                    klær og sko som er egnet for gjennomføringen. Vi oppfordrer alle til å bruke
                    uniform/arbeidstøy.
                </p>
                <p>
                    Til vannredningsposten må du ha med varmt undertøy/ullklær uten glidelås i hals
                    til å bruke under tørrdrakt. Husk også ullsokker. Har du egen tørrdrakt og sko
                    så ta gjerne med dette. Tørt skift er anbefalt å ta med da man kan bli våt under
                    tørrdrakten. Et håndkle kan være lurt å ta med.
                </p>
                <p>
                    På postene «Redning i krevende terreng» og «Tilkomst og evakuering» er det greit
                    at du tar med egen klatresele og hjelm hvis du har dette.
                </p>
                <p>
                    Har du egen sender/mottaker, søkestang og spade så ta gjerne med dette på
                    skredposten.
                </p>
                <p>
                    <b>
                        Eget utstyr må godkjennes av ansvarlig på posten. Du har da selv ansvar for
                        ditt personlige utstyr.
                    </b>
                </p>
                <p>
                    For alle utendørs workshops så må du ha klær og sko etter vær. Været i Lom
                    første uka i juni kan variere veldig både temperatur og nedbørsmessig, men vi
                    krysser fingre for godt vær!
                </p>
                <InfoBox variant="info-muted">
                    <p>
                        Kontaktinfo til ansvarlige for de ulike workshopene finner du i 5-punkts
                        ordrene for hver workshop, og i øvingsdirektivet for øvelsen på lørdag.
                    </p>
                    <button
                        type="button"
                        className="info-box__button info-box__button--muted"
                        onClick={() => onNavigate?.('documents')}
                    >
                        Gå til Dokumenter
                    </button>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Lunsj</h4>
                <InfoItem heading="Workshop tirsdag, torsdag og fredag inkl. drone">
                    <p>
                        Ta med egen niste. Om du ønsker å bestille lunsjpakke fra Bakeriet så er det
                        et tilbud hvor vi administrerer bestillingen og utlevering. Du må bestille
                        via påmeldingssystemet senest kl 10:00 to dager før, og vi leverer ut
                        lunsjpakken i teltet på Nordal hver morgen. Vippskvittering må vises ved
                        utlevering.
                    </p>
                    <p>
                        Hvis arbeidsgiver skal betale lunsjpakken må dette være bekreftet med navn
                        på den det gjelder og vi må ha mottatt fakturaadresse.
                        Bekreftelse/fakturaadresse sendes til sar61@norskluftambulanse.no.
                    </p>
                </InfoItem>
                <InfoItem heading="Workshop skred og/eller hypotermi på Sognefjellet">
                    <p>
                        Her blir det mulig å kjøpe lunsj på Sognefjellshytta, som alternativ til
                        lunsjpakke fra Bakeriet eller egen niste.
                    </p>
                </InfoItem>
                <InfoItem heading="Workshopene innsatsleder og masseskadetriage">
                    <p>Ta med niste/lunsjpakke. Vi sørger for kaffe/te på møterommene.</p>
                </InfoItem>
                <InfoItem heading="Førsteinnsatsseminar tirsdag">
                    <p>
                        Sparebank1 Lom og Skjåk sponser deltakerne med sandwich og kaffe/te til
                        lunsj.
                    </p>
                </InfoItem>
                <InfoItem heading="Hovedkonferanse og minikonferanse onsdag">
                    <p>
                        Sparebank1 Lom og Skjåk sponser alle deltakerne med sandwich og kaffe/te til
                        lunsj. I tillegg vil Bakeriet i Lom stå med egen bod med salg av bakevarer
                        utenfor hallen.
                    </p>
                </InfoItem>
                <InfoItem heading="Øvelse Flåklypa">
                    <p>
                        Sparebank1 Lom og Skjåk sponser alle deltakerne med sandwich og kaffe/te ved
                        debrief i teltet etter øvelsen.
                    </p>
                </InfoItem>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Middag</h4>
                <p>
                    Vi oppfordrer flest mulig til å bli med på middag i teltet hver kveld fra kl
                    18:00.{' '}
                    <b>
                        Middagen serveres utendørs i teltet så husk å kle deg etter vær og
                        temperatur.
                    </b>{' '}
                    Middag bestilles via påmeldingssystemet senest kl 10:00 to dager før.
                    Vippskvittering vises frem ved servering.
                </p>
                <p>
                    For de som får middag dekket av arbeidsgiver så må dere hente
                    &quot;matkort&quot; hos Julie. Hun finner dere i teltet enten på morgenen mellom
                    kl 07:00 - 08:00 eller på ettermiddagen fra kl 17:00. For å få
                    &quot;matkort&quot; må arbeidsgiver ha sendt oss bekreftelse med navn på den det
                    gjelder og fakturaadresse. Dette sendes så snart som mulig til
                    sar61@norskluftambulanse.no.
                </p>
                <InfoBox variant="info-muted">
                    <p>Kontaktperson lunsj/middag: Julie Didriksen, tlf: 953 06 359.</p>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Bilder/Presse</h4>
                <p>
                    Det vil være fotografer fra Stiftelsen Norsk Luftambulanse tilstede gjennom hele
                    uka. Det vil bli tatt bilder fra alle workshoper, konferansene og øvelsen. Hvis
                    du ikke vil bli tatt bilde av så må du si ifra til fotografene.
                </p>
                <InfoBox variant="info-muted">
                    <p>Kontaktperson bilder/presse: Marius Svaleng Andresen, tlf: 452 74 422.</p>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Oppmøtesteder</h4>
                <dl className="profile-list">
                    <ListField
                        label="Redning i krevende terreng"
                        value="Flåklypa"
                        action="Solsidevegen 829, parkering mot elva"
                    />
                    <ListField
                        label="Tilkomst og evakuering"
                        value="Flåklypa"
                        action="Solsidevegen 849, mot elva"
                    />
                    <ListField
                        label="Vannredning - elv"
                        value="Flåklypa"
                        action="Krysset Solsidevegen og Sognefjellsvegen"
                    />
                    <ListField
                        label="Masseskadetriage"
                        value="Fossberg hotell"
                        action="Bergomsvegen 40, Fossbergom"
                    />
                    <ListField
                        label="Innsatsledelse"
                        value="Utgard fleirbrukshus"
                        action="Bergomsvegen 41, Fossbergom"
                    />
                    <ListField
                        label="Drone og teknologi"
                        value="Opsrom Nordal til morgenbrief,"
                        action="Deretter forflytning til Leirdalen"
                    />
                    <ListField
                        label="Førsteinnsats snøskred"
                        value="Sognefjellshytta"
                        action="Sognefjellsvegen 4974, Bøverdalen"
                    />
                    <ListField
                        label="Hypotermi"
                        value="Sognefjellshytta"
                        action="Sognefjellsvegen 4974, Bøverdalen"
                    />
                    <ListField
                        label="HeliTAS"
                        value="Lom brannstasjon"
                        action="Skjæsarøye 1, Fossbergom"
                    />
                    <ListField
                        label="Demo masseskade evakuering"
                        value="Helikopter-området"
                        action="Utenfor Utgard flerbrukshall"
                    />
                    <ListField
                        label="Mini- og hovedkonferanse"
                        value="Utgard fleirbrukshus"
                        action="Bergomsvegen 41, Fossbergom"
                    />
                    <ListField
                        label="DSB Nødnettsforum"
                        value="Norsk fjellsenter"
                        action="Brubakken 2, Fossbergom"
                    />
                    <ListField
                        label="Førsteinnsatsseminar – krevende terreng"
                        value="Utgard fleirbrukshus"
                        action="Bergomsvegen 41, Fossbergom"
                    />
                </dl>

                <InfoItem heading="Bom Leirdalen">
                    <p>
                        For alle som skal inn i Leirdalen og ønsker å slippe å betale bompenger:
                        send registreringsnummer på bilen du skal kjøre til Jørgen Skogmo senest
                        søndag 31. mai på{' '}
                        <a href="mailto:jorgen.hauge.skogmo@nla-teknologi.no">
                            jorgen.hauge.skogmo@nla-teknologi.no
                        </a>
                        .
                    </p>
                    <p>
                        For de som sender reg.nr senere enn søndag kan vi ikke garantere gratis
                        passering.
                    </p>
                </InfoItem>

                <InfoBox variant="info-muted">
                    <p>
                        Deltakerne oppfordres til å fylle opp tilgjengelige biler for minimert
                        antallet biler som reiser inn i Leirdalen.
                    </p>
                </InfoBox>
            </section>

            <section className="profile-section">
                <h4 className="profile-section__heading">Kontakt</h4>
                <p>Alle i arrangørstaben er ikledd sorte vester med SAR61-logo på ryggen.</p>

                <InfoBox variant="info-muted">
                    <p>
                        Har du spørsmål? Huk tak i en av oss i arrangørstaben, eller send oss en
                        melding via{' '}
                        <a href="/om/#kontakt" target="_blank" rel="noopener noreferrer">
                            kontaktskjemaet{' '}
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" />
                        </a>
                        , så hjelper vi deg.
                    </p>
                </InfoBox>

                <InfoItem heading="Kontaktpersoner for workshops">
                    <dl className="profile-list">
                        <ListField
                            label="Redning i krevende terreng"
                            value="Nils Halvor Gryting"
                            action={<a href="tel:+4790197480">{formatPhoneNumber('90197480')}</a>}
                        />
                        <ListField
                            label="Tilkomst og evakuering"
                            value="Nils Halvor Gryting"
                            action={<a href="tel:+4790197480">{formatPhoneNumber('90197480')}</a>}
                        />
                        <ListField
                            label="Vannredning - elv"
                            value="Øystein Brandsar"
                            action={<a href="tel:+4741230743">{formatPhoneNumber('41230743')}</a>}
                        />
                        <ListField
                            label="Masseskadetriage"
                            value="Nils Halvor Gryting"
                            action={<a href="tel:+4790197480">{formatPhoneNumber('90197480')}</a>}
                        />
                        <ListField
                            label="Innsatsledelse"
                            value="Kristian Solemsli"
                            action={<a href="tel:+4741506929">{formatPhoneNumber('41506929')}</a>}
                        />
                        <ListField
                            label="Drone og teknologi"
                            value="Jørgen Skogmo"
                            action={<a href="tel:+4791528095">{formatPhoneNumber('91528095')}</a>}
                        />
                        <ListField
                            label="Førsteinnsats snøskred"
                            value="Albert Lunde"
                            action={<a href="tel:+4791549851">{formatPhoneNumber('91549851')}</a>}
                        />
                        <ListField
                            label="Hypotermi"
                            value="Sigurd Mydske"
                            action={<a href="tel:+4790659586">{formatPhoneNumber('90659586')}</a>}
                        />
                        <ListField
                            label="HeliTAS"
                            value="Mattis Hamborg"
                            action={<a href="tel:+4799282403">{formatPhoneNumber('99282403')}</a>}
                        />
                        <ListField
                            label="Demo masseskade evakuering"
                            value="Trond Vigerust"
                            action={<a href="tel:+4790076323">{formatPhoneNumber('90076323')}</a>}
                        />
                        <ListField
                            label="Mini- og hovedkonferanse"
                            value="Anita Solberg"
                            action={<a href="tel:+4747621037">{formatPhoneNumber('47621037')}</a>}
                        />
                        <ListField
                            label="DSB Nødnettsforum"
                            value="Fredrik Milde"
                            action={<a href="tel:+4793636423">{formatPhoneNumber('93636423')}</a>}
                        />
                        <ListField
                            label="Førsteinnsatsseminar – krevende terreng"
                            value="Albert Lunde"
                            action={<a href="tel:+4791549851">{formatPhoneNumber('91549851')}</a>}
                        />
                    </dl>
                </InfoItem>
            </section>
        </div>
    );
}

export default InfoTab;
